export const SET_CALLS = 'SET_CALLS';

export const setCalls = (calls) => ({
  type: SET_CALLS,
  payload: calls,
});
